import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import { PolicyDialogType as s } from "../../../shared/data/layout/state/index4.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
class e {
  title = "";
  link = "";
  showPrintButton = !0;
  showSaveButton = !0;
}
class x {
  static createPolicyDialogOptions(t, o) {
    switch (t) {
      case s.Disclaimer:
        return new r(o);
      case s.PrivacyPolicy:
        return new l(o);
      case s.Terms:
        return new n(o);
      case s.CookiePolicy:
        return new a(o);
      case s.EditorialPolicy:
        return new c(o);
      case s.EmailPolicy:
        return new u(o);
      default:
        throw new TypeError("Policy Dialog Type is not a valid type");
    }
  }
}
class r extends e {
  constructor(t) {
    super(), this.title = "disclaimer-title", this.link = t.disclaimerLink, this.showPrintButton = !1, this.showSaveButton = !1;
  }
}
class l extends e {
  constructor(t) {
    super(), this.title = "privacy-policy-title", this.link = t.privacyPolicyLink, this.showPrintButton = !0, this.showSaveButton = !0;
  }
}
class n extends e {
  constructor(t) {
    super(), this.title = "terms-of-use-title", this.link = t.termsLink, this.showPrintButton = !0, this.showSaveButton = !0;
  }
}
class a extends e {
  constructor(t) {
    super(), this.title = "cookie-policy", this.link = t.cookiesPolicyLink, this.showPrintButton = !1, this.showSaveButton = !1;
  }
}
class c extends e {
  constructor(t) {
    super(), this.title = "editorial-policy-title", this.link = t.editorialPolicyLink, this.showPrintButton = !0, this.showSaveButton = !0;
  }
}
class u extends e {
  constructor(t) {
    super(), this.title = "email-policy", this.link = t.emailPolicyLink, this.showPrintButton = !1, this.showSaveButton = !1;
  }
}
export {
  e as PolicyDialogOptions,
  x as PolicyDialogOptionsFactory
};
//# sourceMappingURL=index8.js.map
